/**
 * App Config File
 */
const AppConfig = {
   appLogo: require('Assets/img/tsga-white-logo.png'), 
   //development
   // apiurl : 'http://127.0.0.1:8000', 
   // Production 
   apiurl : 'https://portal.tsgacademy.in/Backend/public',   // App Logo
   storageurl : 'https://portal.tsgacademy.in/Backend', // storage url
   brandName: 'TSG',
   appTitle: "TSG Academy"                                                                                                                             ,                                   // Brand Name
   navCollapsed: false,
                                         // Sidebar collapse
   // darkMode: false,                                          // Dark Mode
   boxLayout: false,                                         // Box Layout
   // rtlLayout: false,                                         // RTL Layout
   miniSidebar: false,                                       // Mini Sidebar
   enableSidebarBackgroundImage: true,  
   isDarkSidenav: true,                                   // Set true to dark sidebar
   enableThemeOptions: true,                              // Enable Theme Options
   locale: {
      languageId: 'english',
      locale: 'en',
      name: 'English',
      icon: 'en',
   },
   enableUserTour: process.env.NODE_ENV === 'production' ? true : false,  // Enable / Disable User Tour
   copyRightText: 'TSG © 2022 All Rights Reserved.',      // Copy Right Text
   // light theme colors
   themeColors: {
      'primary': '#5D92F4',
      'secondary': '#677080',
      'success': '#00D014',
      'danger': '#FF3739',
      'warning': '#FFB70F',
      'info': '#00D0BD',
      'dark': '#464D69',
      'default': '#FAFAFA',
      'greyLighten': '#A5A7B2',
      'grey': '#677080',
      'white': '#FFFFFF',
      'purple': '#896BD6',
      'yellow': '#D46B08'
   },
   // dark theme colors
   darkThemeColors: {
      darkBgColor: '#424242'
   }

}

export default AppConfig;
